// This is required because there is error in importing enums
// due to problematic code in payment-methods package.

export enum CheckoutCallbackStates {
  ERROR,
  LOADED,
  PAYMENTDONE,
}

export enum ErrorEnum {
  AuthError,
  AddressValidationError,
  PaymentError,
  OrderError,
  ReviewViewError,
}
